import { useContext, useState } from "react";
import { Delete, Post, handleError } from "../utils/fetch.util";
import { UserContext } from "../contexts/user.context";
import { toast } from "react-toastify";

export default function useBanStaff() {
  const [isLoading, setIsLoading] = useState(false);
  const [blockNationalId, setBlockNationalId] = useState<string>("");
  const [isBanModalOpen, setIsBanModalOpen] = useState(false);
  const [blockReason, setBlockReason] = useState<string>("");
  const [blockDuration, setBlockDuration] = useState<number>(1);
  const [isBlockedForever, setIsBlockedForever] = useState<boolean>(false);
  const { getValidToken } = useContext(UserContext);

  const banStaff = async (
    e: React.FormEvent<HTMLFormElement>,
    nationalId: string,
    onSuccess: () => any,
    updateUI: () => void,
  ) => {
    e.preventDefault();
    setIsLoading(true);

    const res = await Post(
      "staff-black-list/add-staff-blackList",
      {
        national_id: nationalId,
        block_reason: blockReason,
        block_date: new Date(),
        block_duration: Number(blockDuration),
        isBlockedForever: isBlockedForever,
      },
      getValidToken(),
    );

    if (res.error || !res.data) {
      handleError(res);
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
    updateUI();
    onSuccess();
    setBlockReason("");
    setBlockNationalId("");
    setBlockDuration(0);
    toast.success("Staff Banned Successfully");
  };

  const unbanStaff = async (
    blacklist_id: number,
    updateUI: () => void,
    onSuccess?: () => any,
    showError?: boolean,
  ) => {
    setIsLoading(true);

    const res = await Delete(
      `staff-black-list/delete-staff-blackList?blacklist_id=${blacklist_id}`,
      getValidToken(),
    );

    if (res.error || !res.data) {
      setIsLoading(false);
      if (showError) {
        handleError(res);
      }
      return;
    }

    setIsLoading(false);
    updateUI();
    if (onSuccess) onSuccess();
  };

  return {
    unbanStaff,
    banStaff,
    isBanModalOpen,
    setIsBanModalOpen,
    blockReason,
    setBlockReason,
    blockDuration,
    setBlockDuration,
    isLoading,
    setIsLoading,
    setBlockNationalId,
    blockNationalId,
    isBlockedForever,
    setIsBlockedForever,
  };
}
